<template>
  <div :class="className" :style="{height:height,width:width,margin:margin}"/>
</template>

<script>
import resize from '@/mixin/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    margin: {
      type: String,
      default: '0'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions(chartData) {
      let monthList = [], yfData = [], sfData = [], cbData = []
      for (let item of chartData.v_92740012) {
        const cnMonth = this.$getCnMonth(this.$day(item.statisticMonth).month())
        if (!monthList.includes(cnMonth)) {
          monthList.push(cnMonth)
        }
        if (item.detailItem.includes('应发')) {
          yfData.push(item.detailValue)
        }
        if (item.detailItem.includes('实发')) {
          sfData.push(item.detailValue)
        }
        if (item.detailItem.includes('成本')) {
          cbData.push(item.detailValue)
        }
      }

      this.chart.setOption({
        backgroundColor: '#FFFFFF',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          right: '4%',
          data: [
            {
              name: this.$t('gross'), // '应发',
              icon: 'roundRect'
            },
            {
              name: this.$t('net'), // '实发',
              icon: 'roundRect'
            },
            {
              name: this.$t('cost'), // '成本',
              icon: 'roundRect'
            }
          ]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: monthList
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: this.$t('cost'),
            type: 'line',
            areaStyle: {
              // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#6EC58B' // 0% 处的颜色
                }, {
                  offset: 1, color: '#FFFFFF' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#6EC58B'
            },
            data: cbData
          },
          {
            name: this.$t('gross'),
            type: 'line',
            areaStyle: {
              // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#0093AB' // 0% 处的颜色
                }, {
                  offset: 1, color: '#FFFFFF' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#0093AB'
            },
            data: yfData
          },
          {
            name: this.$t('net'),
            type: 'line',
            areaStyle: {
              // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#3371C5' // 0% 处的颜色
                }, {
                  offset: 1, color: '#FFFFFF' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#3371C5'
            },
            data: sfData
          }
        ]
      })
    }
  }
}
</script>
